import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tooltip } from 'primereact/tooltip';
import { Calendar } from 'primereact/calendar';
import { ColumnGroup } from 'primereact/columngroup';
import { fetchAllCatalogs } from '@/redux/slices/catalogs/catalogsSlices';
import { Row } from 'primereact/row';
import 'primeicons/primeicons.css';
import { localeCalendar, roundNumber } from '@utils';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllCompany } from '@/redux/slices/company/companySlices';
import { addLocale } from 'primereact/api';
import { selectUserData } from '@reduxSlices/user/userSlices';
import { Toast } from 'primereact/toast';
import './styles.scss';
import { fetchProducts } from '@/redux/slices/products/productsSlices';
import { formatedItemsExport } from './formatedItems';
import formatedProducts from './formatedProducts';
import moment from 'moment';
import 'moment-timezone';
moment.tz.setDefault('Europe/Kiev');

const Home = () => {
  const dispatch = useDispatch();
  const [datesInventory, setDatesInventory] = useState(null);
  const [selectCompany, setSelectCompany] = useState(null);
  const [selectStorage, setSelectStorage] = useState(null);
  const { allCompany } = useSelector((state) => state.company);
  const { allCatalogs } = useSelector((state) => state.catalogs);
  const arrayCompany = allCompany.map(({ name, _id }) => ({ name, code: _id }));
  const { role, company_id: userCompanyId } = useSelector(selectUserData) ?? {};
  const { items = [], status, error } = useSelector((state) => state.products) ?? {};
  const toast = useRef(null);
  addLocale('ua', localeCalendar);
  const formatedArrayProducts = formatedProducts(items, datesInventory);

  const toKievTime = (date) => {
    if (!date) return '';
    const newDate = moment(date).tz('Europe/Kiev');
    return newDate.toDate();
  };

  const cols = [
    ...(role === 'admin'
      ? [
          {
            field: 'company_name',
            header: 'Підриємство',
            style: { maxWidth: '320px', minWidth: '250px' },
            sortable: true,
          },
        ]
      : []),
    { field: 'barcode', header: 'Бирки №', style: { maxWidth: '200px', minWidth: '150px' } },
    {
      field: 'product',
      header: 'Продукція',
      style: { maxWidth: '400px', minWidth: '300px' },
    },
    { field: 'storage', header: 'Склад', style: { maxWidth: '300px', minWidth: '250px' } },
    {
      field: 'capacity',
      header: "Об'єм",
      style: { maxWidth: '400px', minWidth: '300px' },
    },
    { field: 'length', header: 'Довжина', style: { maxWidth: '220px', minWidth: '200px' } },
    { field: 'document_no', header: 'Приймання №', style: { maxWidth: '250px', minWidth: '210px' } },
    { field: 'supplier', header: 'Постачальник', style: { maxWidth: '280px', minWidth: '200px' } },
    { field: 'carrier', header: 'Перевізник', style: { maxWidth: '300px', minWidth: '200px' } },
    {
      field: 'date_inventory',
      header: 'Дата крайньої інвентарізації',
      style: { maxWidth: '310px', minWidth: '290px' },
      sortable: true,
    },
    {
      field: 'date_inventory_history',
      header: 'Історія інвентарізацій',
      style: { maxWidth: '300px', minWidth: '250px' },
    },

    // ...(role === 'admin' ? [{ field: 'user', header: 'Користувач', style: { maxWidth: '250px' } }] : []),
  ];

  const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
      }
    });
  };

  const exportExcel = () => {
    const arrItems = formatedItemsExport(formatedArrayProducts, role);
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(arrItems);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });

      saveAsExcelFile(excelBuffer, 'products');
    });
  };

  // const updateLoad = (companyId, datesInventory) => () => {
  //   dispatch(fetchProducts(productsGetParams(companyId, datesInventory)));
  // };

  const productsGetParams = (companyId, datesInventory = [], storagesId) => {
    const [startDateInventory, finishDateInventory] = datesInventory ?? [];
    return {
      ...(companyId ? { companyId } : {}),
      ...(storagesId ? { storagesId } : {}),
      ...(startDateInventory && finishDateInventory
        ? {
            startDateInventory: moment(startDateInventory).format(),
            finishDateInventory: moment(finishDateInventory).format(),
          }
        : {}),
    };
  };

  const storagesItems =
    allCatalogs?.['storages']
      ?.filter((item) => [selectCompany?.code, userCompanyId].includes(item?.company_id))
      .map(({ name, _id }) => ({
        label: name,
        value: _id,
      })) ?? [];

  storagesItems.push({ label: 'Всі склади', value: 'all' });

  useEffect(() => {
    const companyId = selectCompany?.code ? selectCompany?.code : null;
    const storagesId = selectStorage && selectStorage !== 'all' ? selectStorage : null;

    dispatch(fetchProducts(productsGetParams(companyId ?? userCompanyId, datesInventory, storagesId)));
  }, [selectCompany, datesInventory, selectStorage]);

  useEffect(() => {
    if (!selectCompany && role === 'admin') {
      setSelectCompany(arrayCompany[0]);
    }
  }, [arrayCompany]);

  useEffect(() => {
    if (status === 'failed') {
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }
  }, [error, status]);

  useEffect(() => {
    dispatch(fetchAllCompany());
    dispatch(fetchAllCatalogs());
  }, []);

  const handleDateChange = (value) => {
    if (value === null) {
      return setDatesInventory(null);
    }
    const [start, end] = value ?? [];
    setDatesInventory([toKievTime(start), toKievTime(end)]);
  };

  const header = (
    <div className='flex header-home-table align-items-center justify-content-between gap-3'>
      <div className='flex align-items-center gap-3'>
        <Button
          type='button'
          icon='pi pi-file-excel'
          severity='success'
          rounded
          onClick={exportExcel}
          data-pr-tooltip='XLS'
        />
      </div>
      <div className='flex align-items-center gap-3'>
        <Calendar
          value={datesInventory}
          onChange={(e) => handleDateChange(e.value)}
          selectionMode='range'
          placeholder='Період інвентарізації'
          className='catalog__calendar w-full md:w-15rem'
          locale='ua'
          showIcon
          dateFormat='dd.mm.yy'
          maxDate={new Date()}
        />

        {role === 'admin' && allCompany?.length > 0 && (
          <Dropdown
            value={selectCompany}
            onChange={(e) => {
              setSelectCompany(e.value);
              setSelectStorage('all');
            }}
            className='catalog__select w-full md:w-20rem'
            options={arrayCompany}
            optionLabel='name'
            placeholder='Виберіть підриємство'
            emptyMessage='Поки що немає підриємств'
          />
        )}
        <Dropdown
          value={selectStorage}
          onChange={(e) => setSelectStorage(e.value)}
          className='catalog__select w-full md:w-20rem'
          options={storagesItems}
          placeholder='Виберіть cклад'
          emptyMessage='Поки що немає складів'
        />
      </div>
    </div>
  );


  const sumTotal = () => {
    const capacity = formatedArrayProducts.reduce((acc, item) => acc + item.capacity, 0);
    return `${roundNumber(capacity)}м³`;
  };

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer="Об'єм:" colSpan={role === 'admin' ? 4 : 3} footerStyle={{ textAlign: 'right' }} />
        <Column footer={sumTotal} />
        <Column colSpan={8} footerStyle={{ textAlign: 'right' }} />
      </Row>
    </ColumnGroup>
  );

  return (
    <div className='page'>
      <h2 className='page__title'>Список продукцій</h2>
      <DataTable
        value={formatedArrayProducts}
        header={header}
        paginator
        showGridlines
        rows={50}
        responsiveLayout='scroll'
        scrollable
        // scrollHeight='400px'
        emptyMessage='Поки що немає даних'
        footerColumnGroup={footerGroup}
      >
        {cols.map(({ field, header, ...props }, index) => (
          <Column key={index} field={field} header={header} {...props} />
        ))}
      </DataTable>
      <Toast ref={toast} />
    </div>
  );
};

export default Home;
